import findColumn from 'data-frames/util/findColumn';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {ConfigValidationFunction, AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';
import * as Helpers from './StepConfigValidationHelpers';

const validateConfig: ConfigValidationFunction<PipelineStepType.UNPIVOT_DATASET, 0> = (
  config,
  {'Input dataset': [dataFrameSpec]}
) => {
  const duplicateUnpivotColumnsMsg = Helpers.getDuplicateColumnsMessage(
    dataFrameSpec,
    config.unpivotColumns,
    'Cannot unpivot by the same column more than once.'
  );

  const existingNameColumn = findColumn(dataFrameSpec, config.nameColumn);
  const existingNameColumnMsg =
    existingNameColumn == null
      ? null
      : `Cannot use existing column name for name column: ${config.nameColumn}`;

  const existingValueColumn = findColumn(dataFrameSpec, config.valueColumn);
  const existingValueColumnMsg =
    existingValueColumn == null
      ? null
      : `Cannot use existing column name for value column: ${config.valueColumn}`;

  const conflictingNameAndValueColumnMsg =
    config.nameColumn === config.valueColumn ? 'Name and value columns cannot be the same' : null;

  return Helpers.coalesceMessages(
    duplicateUnpivotColumnsMsg,
    existingNameColumnMsg,
    existingValueColumnMsg,
    conflictingNameAndValueColumnMsg
  );
};

export default {
  stepType: PipelineStepType.UNPIVOT_DATASET,
  stepVersion: 0,
  validateConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.UNPIVOT_DATASET, 0>;
